<template>
  <div class="check">
    <header class="header-1" v-if="!userInfo.userName">
      <router-link to="/login">用户登录</router-link>
      <router-link to="/login?page=1">用户注册</router-link>
    </header>
    <header class="header-2" v-if="userInfo.userName">
      <div class="left">
        <router-link to="/">个人中心</router-link>
        <router-link to="/court">我的开庭</router-link>
        <router-link to="/sign">笔录签名</router-link>
      </div>
      <div class="right">
        <span> <img src="../assets/icon_check_user.png" alt=""> 欢迎您，{{ userInfo.userName }} </span>
        <span class="click" @click="_exit"> <img src="../assets/icon_check_exit.png" alt=""> 退出账户 </span>
      </div>
    </header>
    <section>
      <div class="info">
        <div class="logo">
          <img src="../assets/icon_logo.png" alt="">
        </div>
        <div class="title">
          湛江仲裁委员会(湛江国际仲裁院）
        </div>
        <div class="desc">
          <img src="../assets/icon_check_left.png" alt="">
          <span>网上开庭</span>
          <img src="../assets/icon_check_right.png" alt="">
        </div>
      </div>
      <div class="input">
        <input type="text" v-model="code" placeholder="请输入邀请码">
        <button class="click" @click="_toVideoCall">进入庭审</button>
      </div>
    </section>
    <CaseInfo :id="id" :status="caseInfoStatus" :infoType="1" @handle="_handleCaseInfo"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CaseInfo from '@/components/CaseInfo'
import { getVideoCallRoomId } from '@/service/getData'
export default {
  name: 'Check',
  data () {
    return {
      caseInfoStatus: false,
      exitStatus: true,
      code: '',
      roomId: 0,
      id: 0
    }
  },
  components: {
    CaseInfo
  },
  computed: mapState(['userInfo']),
  methods: {
    _handleCaseInfo (e) {
      switch (e.event) {
        case -1:
          this.caseInfoStatus = false
          break
        case 1:
          this.$router.push({ path: '/call', query: { roomId: this.roomId, id: this.id } })
          break
      }
    },
    async _toVideoCall () {
      if (this.$verify.empty(this.code)) { this.$message.error('请输入邀请码'); return false }
      var res = await getVideoCallRoomId(this.code)
      if (res.code === 1) {
        this.roomId = res.data.roomId
        this.id = res.data.meetingId
        this.caseInfoStatus = true
        // this.$router.push({ path: '/call', query: { roomId: this.roomId, id: this.id } })
      } else if (res.code === 10000 || res.code === 10002) {
        this.$message.error('请登录')
        this.$router.push('/login')
      } else {
        this.$message.error(res.msg)
      }
    },
    _exit () {
      const _this = this
      if (_this.exitStatus) {
        _this.exitStatus = false
        window.localStorage.clear()
        _this.$store.commit('SET_USER_INFO', {})
        _this.$message.success('退出登录').then(() => {
          _this.$router.push({ path: '/' })
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../style/mixin";
.check{
  position: relative;
  @include wh(100%, 100%);
  background-image: url("../assets/check_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  section {
    .input {
      width: 7.342rem;
      margin: 0 auto;
      margin-top: 0.833rem;
      background-color: rgba(61,151,230, 0.4);
      border-radius: 0.125rem;
      height: 0.958rem;
      padding: 0.1375rem;
      display: flex;
      input {
        flex: 1;
        background-color: #fff;
        height: 100%;
        border-radius: 0.083rem;
        padding: 0 0.1375rem;
        margin-right: 0.1375rem;
      }
      button {
        background-image: url('../assets/icon_check_btn_bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-color: transparent;
        width: 1.85rem;
        color: #fff;
        font-size: 0.25rem;
        font-family: PingFang SC;
        font-weight: bold;
      }
    }
    .info {
      margin-top: 1.2rem;
      text-align: center;
      .desc {
        font-size: 0.3rem;
        font-family: PingFang SC;
        font-weight: bold;
        margin-top: 0.625rem;
        span {
          color: #fff;
          margin: 0 0.117rem;
        }
        img {
          vertical-align: middle;
          @include wh(0.483rem, 0.217rem);
        }
      }
      .title {
        font-size: 0.4rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        margin-top: 0.392rem;
      }
      img {
        @include wh(1.167rem, 1.167rem)
      }
    }
  }
  .header-2 {
    padding: 0 0.458rem;
    height: 0.883rem;
    line-height: 0.883rem;
    a {
      font-size: 0.15rem;
      font-family: PingFang SC;
    }
    .right {
      color: #4A4A4A;
      img {
        @include wh(0.167rem, 0.167rem);
        vertical-align: middle;
        margin-right: 0.133rem;
      }
      .click {
        margin-left: 0.517rem;
        position: relative;
        &::after {
          position: absolute;
          content: ' ';
          left: -0.25rem;
          background-color: #4A4A4A;
          top: 0;
          bottom: 0;
          width: 0.025rem;
          border-radius: 0.013rem;
        }
      }
    }
    .left {
      a {
        color: #fff;
        font-weight: bold;
        background-color: #2176C1;
        padding: 0.133rem 0.283rem;
        border-radius: 0.208rem;
        margin-right: 0.125rem;
      }
    }
  }
  .header-1 {
    font-size: 0.15rem;
    font-family: PingFang SC;
    font-weight: bold;
    padding-top: 0.425rem;
    overflow: auto;
    a {
      display: inline-block;
      color: #fbf9fb;
      background-color: #275e9f;
      border: 0.008rem solid #5e88b8;
      border-radius: 0.083rem;
      padding: 0.092rem 0.183rem;
      margin-left: 1.2rem;
      &:last-child {
        margin-left: 0.2rem;
      }
    }
  }
}
</style>
